import { Global } from "../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ToastUI extends cc.Component {
    @property(cc.Node)
    nodeOk: cc.Node = null
    
    @property(cc.Node)
    nodeError: cc.Node = null
    
    @property(cc.Node)
    nodeWarnning: cc.Node = null

    @property(cc.Label)
    lblText: cc.Label = null;

    @property(cc.Animation)
    animation: cc.Animation = null

    @property
    set toastType (type: Global.ToastType) {
        this.nodeOk.active = false
        this.nodeError.active = false
        this.nodeWarnning.active = false
        
        if (type === Global.ToastType.OK) {
            this.nodeOk.active = true
        }else if (type === Global.ToastType.Error) {
            this.nodeError.active = true
        }else if (type === Global.ToastType.Warnning) {
            this.nodeWarnning.active = true
        }
    }

    @property
    set content (value : string) {
        this.lblText.string = value && value.replace("<br/>","\n");
    }

    start () {
        this.animation.on('finished', function () {
            this.node.destroy()
        }, this)
    }
}
